<template>
  <AppInfoBlock
    class="match_length_info_block"
    :type="lengthsMatch ? 'success' : 'error'"
  >
    <span class="match_length_info_block__content">
      <span class="match_length_info_block__label"
        >L1+L2+L3/{{ $t("Comprimento de vãos") }}:</span
      >{{ lUnitsLength.toFixed(2) }}m / {{ modelSpansLength.toFixed(2) }}m
    </span>
  </AppInfoBlock>
</template>

<script>
import AppInfoBlock from "@/components/app/InfoBlock";

export default {
  components: {
    AppInfoBlock,
  },

  props: {
    lUnitsLength: {
      required: true,
      type: Number,
    },
    modelSpansLength: {
      required: true,
      type: Number,
    },
  },

  computed: {
    lengthsMatch() {
      return this.lUnitsLength === this.modelSpansLength;
    },
  },
};
</script>

<style lang="scss" scoped>
.match_length_info_block {
  margin-bottom: 8px;
  margin-top: 3px;
  max-width: 411px;
}

.match_length_info_block__content {
  display: flex;
  justify-content: space-between;
}

.match_length_info_block__label {
  text-transform: uppercase;
}
</style>
